export class OTPResponse {
    otp: string;
    otpExpiresIn: number;
    accountId: number;
    fullName: string;
    error: boolean;
    errorDescription: string;
}